import styles from './FJImageUpload.module.less';
import ReUploadIcon from '../../../assets/svg/re-upload.svg?react';
import AddFileWhiteIcon from '../../../assets/svg/add-file-white.svg?react';
import FJLocalStore from '../../../store/FJLocalStore';
import { UPLOAD_FILE_TYPE_NO_GIF } from '../../../config/dataConfig/FJGenerateData';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useRef, useState } from 'react';
import FJPreviewBox from '../../../common/components/FJPreviewBox/FJPreviewBox';
import UploadBorderHoverIcon from '../../../assets/svg/upload-border-hover.svg?react';
import UploadBorderIcon from '../../../assets/svg/upload-border.svg?react';
import UploadDragAddIcon from '../../../assets/svg/upload-drag-add.svg?react';

const FJImageUpload = props => {
    const {
        imageInfo = {},
        uploadImg,
        defaultIcon,
        uploadText = 'upload-image',
        smallIcon,
        className,
        uploadTextClassName,
        openMediaLibrary,
    } = props;
    const { src: imgSrc } = imageInfo;
    const inputRef = useRef(null);
    const [isDraggingFile, setIsDraggingFile] = useState(false);
    const _onUploadImg = e => {
        const file = e.target.files[0];
        uploadImg(file);
        e.target.value = null;
    };

    const _onClick = () => {
        if (window.isEditPage && openMediaLibrary) {
            openMediaLibrary();
        } else if (inputRef.current) {
            inputRef.current.click();
        }
    };
    const _onDragOver = e => {
        e.stopPropagation();
        e.preventDefault();
        setIsDraggingFile(true);
    };

    const _onDragLeave = e => {
        e.stopPropagation();
        e.preventDefault();
        setIsDraggingFile(false);
    };

    const _onDragDrop = e => {
        e.stopPropagation();
        e.preventDefault();
        setIsDraggingFile(false);
        let files = e.dataTransfer.files;
        if (files && files.length > 0) {
            const file = files[0];
            uploadImg(file);
        }
    };
    return (
        <div
            className={classNames(styles.box, imgSrc ? styles.has_img : '', className)}
            onClick={_onClick}
            onDragOver={_onDragOver}
            onDrop={_onDragDrop}
            onDragLeave={_onDragLeave}
        >
            {imgSrc ? (
                <>
                    <img className={styles.preview_img} src={imgSrc} alt='' loading='lazy' />
                    <div className={classNames(styles.blur_mask, isDraggingFile ? styles.dragging : '')}>
                        {isDraggingFile ? <AddFileWhiteIcon /> : <ReUploadIcon />}
                        <span className={styles.reupload_text}>
                            {isDraggingFile ? FJLocalStore._('drag-and-drop') : FJLocalStore._('change-image')}
                        </span>
                    </div>
                    <div className={styles.small_icon}>{smallIcon}</div>
                </>
            ) : (
                <div className={classNames(styles.blank_box, isDraggingFile ? styles.dragging : '')}>
                    {isDraggingFile ? <UploadDragAddIcon /> : defaultIcon}
                    <span className={classNames(styles.blank_text, uploadTextClassName)}>
                        {isDraggingFile ? FJLocalStore._('drag-and-drop') : FJLocalStore._(uploadText)}
                    </span>
                    <UploadBorderHoverIcon className={styles.upload_border_hover} />
                    <UploadBorderIcon className={styles.upload_border} />
                </div>
            )}
            <input
                type='file'
                ref={inputRef}
                className={styles.file_input}
                accept={UPLOAD_FILE_TYPE_NO_GIF}
                onChange={_onUploadImg}
            />

            <div className={styles.dragging_mask}></div>
            <FJPreviewBox imageInfo={imageInfo} />
        </div>
    );
};
FJImageUpload.propTypes = {
    imageInfo: PropTypes.object,
    uploadImg: PropTypes.func,
    defaultIcon: PropTypes.node,
    uploadText: PropTypes.string,
    smallIcon: PropTypes.node,
    className: PropTypes.string,
    uploadTextClassName: PropTypes.string,
    openMediaLibrary: PropTypes.func,
};

export default FJImageUpload;
